var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cc-facebook__tab"},[_c(_setup.AdSetName),_c(_setup.Conversions),_c(_setup.BudgetAndSchedule),_c(_setup.AudienceControls),_c(_setup.Placements)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }